export default __webpack_public_path__ + "static/media/042-cabbage.ff399484.svg";